import React, { Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";

// Plotly is loaded on demand (same chunk as the other plots).
const WidthGroupPlotInner = React.lazy(() => import("./WidthGroupPlotInner"));

/** See WidthGroupPlotInner for the props. */
export default function WidthGroupPlot(props) {
    const height = props.height ?? 420;
    return (
        <Suspense
            fallback={
                <Box sx={{ height, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={28} thickness={4} aria-label="Loading the width groups" />
                </Box>
            }
        >
            <WidthGroupPlotInner {...props} />
        </Suspense>
    );
}
